import { Box, Button, Grid } from '@material-ui/core'

import CalistaUiComponentTranslationText from 'src/views/common/CalistaUiComponentTranslationText'
import ManageScheduleTranslationText from '../ManageScheduleTranslationText'
import React from 'react'
import { components } from 'cng-web-lib'

const {
    form : {
        adapter: {
            useFormAdapter:{ useField, useFormikContext }
        }
    }
} = components

function AddScheduleFinishButtonComponent(props){

    const translatedTextsObject = CalistaUiComponentTranslationText()
    const msTranslatedTextsObject = ManageScheduleTranslationText()
    const { submitForm, setFieldValue } = useFormikContext()
    
    return (
        <Box pl={5} pr={5} pt={4} pb={4}>
            <Grid container xs={12} sm={12}>
                <Grid xs={6} sm={6} justify="flex-start">
                    <Button variant="contained"
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            props.onBack()
                            }
                        }
                        classes={{ root: 'ng-button-filled-secondary' }}
                    >
                        {props.serarchSchedule ? msTranslatedTextsObject.backToSearchSchedule : msTranslatedTextsObject.backToManageSchedule}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddScheduleFinishButtonComponent